import './PeriscopeTag.scss';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarRecord } from '@ui/records';
import { SonarTagDisplay } from '@ui/tags/SonarTag';
import { SonarTag as SonarTagType } from '@sonar-software/sonar-core';
import { useTagReference } from '@hooks';
import React, { useCallback } from 'react';

export type TagClickHandler = (tag: SonarTagType) => void;

export interface PeriscopeTagProps {
	onTagClick?: TagClickHandler;
	tagId: number;
}

export const PeriscopeTag: React.FC<PeriscopeTagProps> = ({ onTagClick, tagId }) => {
	const tag = useTagReference(tagId);

	const handleClick = useCallback(() => {
		if (onTagClick) {
			onTagClick(tag);
		}
	}, [ tag, onTagClick ]);

	const info =
		<div className='periscope-tag'>
			<SonarTagDisplay
				showDescription
				tagId={ tagId } />
		</div>;

	return (
		<SonarRecord
			name={ info }
			onClick={ handleClick }
			sonarObjectId={ null }
			sonarObjectType={ SonarObjectType.SonarTag } />
	);
};
